import Vue from "vue";
// import BootstrapVue from "bootstrap-vue";
import {
  BVConfigPlugin,
  LayoutPlugin,
  AlertPlugin,
  ButtonPlugin
} from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./scss/custom.scss";

Vue.use(BVConfigPlugin, {
  breakpoints: ["tiny", "small", "normal"]
});

Vue.use(LayoutPlugin);
Vue.use(AlertPlugin);
Vue.use(ButtonPlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
